import React, { useState, useEffect } from "react";
import classNames from "classnames/bind";
import "./styles.scss";

const InputCheckbox = (props) => {
  const [checked, setChecked] = useState(props.checked);
  const { label, margin, index, disabled, className, onSelect, background } =
    props;

  useEffect(() => {
    setChecked(props.checked);
  }, [props.checked]);

  const handleClick = (e) => {
    e.preventDefault();
    setChecked(!checked);
    onSelect(!checked, index);
  };

  const someStyle = {
    "--backgroundColor": background || "#36a3f7",
  };

  return (
    <div
      className={`inputCheckbox ${className ? className : ""}`}
      style={{ margin }}
    >
      <input
        type="checkbox"
        className="checkbox"
        onClick={handleClick}
        disabled={disabled}
      />
      <div
        className={`checkboxLabel ${props.displayBlock ? "displayBlock" : ""}`}
      >
        <svg
          className={classNames({
            ["svg"]: true,
            ["svgChecked"]: checked,
          })}
          viewBox="0 0 20 20"
        >
          <path
            d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
            style={{ stroke: "white", fill: "white" }}
          />
        </svg>
        <label
          className={`${classNames({
            ["label"]: true,
            ["labelChecked"]: checked,
          })}`}
          style={someStyle}
        >
          {label}
        </label>
      </div>
    </div>
  );
};

export default InputCheckbox;
